import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {

  mangentoUrl = environment.apiURL
  constructor(private http: HttpClient) { }

  productsOfPromotion(data):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V3/productsOfPromotion`, data);
  }
}
